import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Checkbox, Icon, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { GridContainer, TypeSelector } from './style';
import GraphicsTab from './GraphicsTab';
import CoursesTab from './CoursesTab';
import UsersTab from './UsersTab';
import {
  MULTI_PRINT_MY_ACTIVITIES,
  MULTI_PRINT_MY_CHARTS_CSV,
  MULTI_PRINT_MY_COURSES,
  MULTI_PRINT_MY_USERS,
  PRINT_ACCESS_CSV,
  PRINT_ACTIVITIES_CSV,
  PRINT_CATEGORIES_CSV,
  PRINT_COURSES_CSV,
  PRINT_MY_CATEGORIES,
  PRINT_MY_TUTORS,
  PRINT_MY_TUTORS_CSV,
  PRINT_SETTINGS_RESET,
  STATS_USER_LIST,
} from '../../../../app/redux/actions/statistics';
import { LoadingStep } from '../ModalCreateCourse/style';
import { getLabelByReportType } from '../../../../utils/labels';
import TutorsTab from './TutorsTab';
import CategoriesTab from './CategoriesTab';
import ActivitiesTab from './ActivitiesTab';
import routes from '../../../../routes';
import storage from '../../../../app/api/storage';

export const EXPORT_TABS = {
  CHARTS: 'charts',
  COURSES: 'courses',
  USERS: 'users',
  TUTORS: 'tutors',
  CATEGORIES: 'categories',
  ACTIVITIES: 'activities',
};

const TabSelector = ({
  selectedTab,
  setSelectedTab,
  tabName,
  label,
  checked,
  onClickReport,
}) => (
  <TypeSelector
    className={selectedTab === tabName ? 'active' : ''}
    onClick={() => setSelectedTab(tabName)}
  >
    <Text type="b4">{label}</Text>
    <Checkbox
      name="charts"
      onChange={() => onClickReport(tabName)}
      checked={checked}
      label={label}
      hiddenLabel
    />
  </TypeSelector>
);
TabSelector.propTypes = {
  selectedTab: PropTypes.string,
  setSelectedTab: PropTypes.func,
  tabName: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onClickReport: PropTypes.func,
};

export const ModalDownloadReportId = 'ModalDownloadReport';
const allReports = [];

const ModalDownloadReport = ({
  mediaIsPhone,
  isOpen,
  currentId,
  isSupervisor,
  printSettings,
  printStatus,
  multiPrintMyChartsCSV,
  multiPrintMyCourses,
  multiPrintMyUsers,
  printMyTutors,
  printMyCategories,
  multiPrintMyActivities,
  printAccessCSV,
  printMyTutorsCSV,
  printCateoriesCSV,
  printCoursesCSV,
  printActivitiesCSV,
  modalClose,
  resetPrintSettings,
  getUsers,
}) => {
  const scrollableAreaRef = useRef(null);
  const [selectedReports, setSelectedReports] = useState([...allReports]);
  const [selectedTab, setSelectedTab] = useState(EXPORT_TABS.CHARTS);
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    if (isOpen && currentId === ModalDownloadReportId) {
      getUsers({ filters_only: true });
    }
    return () => {
      if (isOpen && currentId === ModalDownloadReportId) {
        resetPrintSettings();
        setSelectedReports([...allReports]);
        setSelectedTab(EXPORT_TABS.CHARTS);
        setIsPrinting(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const onClickReport = (id) => {
    const index = selectedReports?.findIndex((rId) => rId === id);
    const newReports = [...selectedReports];
    if (index === -1) newReports.push(id);
    else newReports.splice(index, 1);
    setSelectedReports([...newReports]);
  };

  const renderTab = () => {
    return (
      <>
        <div className={selectedTab === EXPORT_TABS.CHARTS ? '' : 'd-none'}>
          <GraphicsTab />
        </div>
        <div className={selectedTab === EXPORT_TABS.COURSES ? '' : 'd-none'}>
          <CoursesTab />
        </div>
        <div className={selectedTab === EXPORT_TABS.USERS ? '' : 'd-none'}>
          <UsersTab />
        </div>
        <div className={selectedTab === EXPORT_TABS.TUTORS ? '' : 'd-none'}>
          <TutorsTab />
        </div>
        <div className={selectedTab === EXPORT_TABS.CATEGORIES ? '' : 'd-none'}>
          <CategoriesTab />
        </div>
        <div className={selectedTab === EXPORT_TABS.ACTIVITIES ? '' : 'd-none'}>
          <ActivitiesTab />
        </div>
      </>
    );
  };

  const startDownload = () => {
    const { charts, courses, users, tutors, categories, activities } =
      printSettings || {};
    // CHARTS TAB
    if (
      selectedReports?.includes('charts') &&
      Object.keys(charts)?.length > 0
    ) {
      if (charts?.format === 'pdf') {
        // users
        storage.write('filters', { ...charts });
        window.open(
          `${window.location.origin}${routes.downloadPdf.path}`,
          '_blank'
        );
        modalClose();
      } else {
        // users
        const completion_status_array = ['', 'incomplete', 'completed'];
        multiPrintMyChartsCSV({
          completion_status_array,
          filters: charts?.users?.filter?.map((f) => f.value),
          start_date: charts?.users?.start_date,
          end_date: charts?.users?.end_date,
        });
        if (isSupervisor) {
          printAccessCSV({
            start_date: charts?.access?.start_date,
            end_date: charts?.access?.end_date,
          });
          printMyTutorsCSV({
            completion_status_array,
            filters: charts?.users?.filter?.map((f) => f.value),
            start_date: charts?.users?.start_date,
            end_date: charts?.users?.end_date,
          });
          printCateoriesCSV({
            start_date: charts?.categories?.start_date,
            end_date: charts?.categories?.end_date,
          });
          printCoursesCSV({
            type_array: (charts?.courses?.filter || []).map((f) => f.value),
            start_date: charts?.courses?.start_date,
            end_date: charts?.courses?.end_date,
          });
          printActivitiesCSV({
            start_date: charts?.activities?.start_date,
            end_date: charts?.activities?.end_date,
          });
        }
      }
    }
    // COURSES TAB
    if (
      courses?.selectedCourses?.length > 0 &&
      (courses?.activities || courses?.users || courses?.survey)
    ) {
      const export_types = [];
      courses?.activities && export_types.push('activities');
      courses?.users && export_types.push('users');
      courses?.survey && export_types.push('survey');
      multiPrintMyCourses({
        export_types,
        course_ids: courses?.selectedCourses?.map((c) => c?.id),
        courses: courses?.selectedCourses,
      });
    }
    // USERS TAB
    if (selectedReports?.includes('users')) {
      const filters = { ...users, selectedCourse: users?.selectedCourse?.id };
      const { export_types } = users;
      delete filters?.export_types;
      multiPrintMyUsers({
        export_types,
        filters,
      });
    }
    // TUTORS TAB
    if (selectedReports?.includes('tutors')) {
      const filters = { ...tutors };
      printMyTutors({
        filters,
      });
    }
    // CATEGORIES TAB
    if (selectedReports?.includes('categories')) {
      const filters = { ...categories };
      printMyCategories({
        filters,
      });
    }
    // ACTIVITIES TAB
    if (selectedReports?.includes('activities')) {
      const filters = { ...activities };
      const { export_types } = activities;
      delete filters?.export_types;
      multiPrintMyActivities({
        export_types,
        filters,
      });
    }
  };

  const btnDisabled = useCallback(() => {
    const {
      charts = {},
      courses = {},
      users = {},
      tutors = {},
      categories = {},
      activities = {},
    } = printSettings;
    const chartsStatus = (Object.values(charts) || [])?.filter(
      (field) => field?.status
    );
    return (
      selectedReports?.length === 0 ||
      (selectedReports?.includes(EXPORT_TABS.CHARTS) &&
        (isSupervisor
          ? chartsStatus?.findIndex(({ status }) => status !== 'ok') >= 0
          : charts?.users.status !== 'ok')) ||
      (selectedReports?.includes(EXPORT_TABS.COURSES) &&
        !courses?.selectedCourses?.length > 0) ||
      (selectedReports?.includes(EXPORT_TABS.USERS) &&
        (!users?.ffoo ||
          (users?.export_types?.includes('users_activities') &&
            !users?.selectedCourse))) ||
      (selectedReports?.includes(EXPORT_TABS.TUTORS) && !tutors?.ffoo) ||
      (selectedReports?.includes(EXPORT_TABS.CATEGORIES) &&
        (!categories?.start_date || !categories?.end_date)) ||
      (selectedReports?.includes(EXPORT_TABS.ACTIVITIES) &&
        !activities?.single_categories)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printSettings, selectedReports]);

  return (
    <Modal
      title="Download statistiche"
      mbTitle={26}
      description="
      Per procedere al download delle statistiche è necessario prima
      selezionare le aree d’interesse e poi definirne le relative
      impostazioni. Ogni area d’interesse ha specifiche tipologie
      d’impostazione la cui definizione è necessaria per abilitare l’export.
      L’export può essere effettuato contestualmente per più di un’area
      d’interesse."
      modalId={ModalDownloadReportId}
      scrollableAreaRef={scrollableAreaRef}
      forceOpen={isPrinting}
      className="max-size"
    >
      <ScrollableArea ref={scrollableAreaRef}>
        {isPrinting ? (
          <>
            {Object.values(printStatus || {}).findIndex(
              (v) => v === 'loading'
            ) >= 0 && (
              <>
                <Text type="h2" mb={8}>
                  Non chiudere la pagina, l’operazione potrebbe richiedere
                  diversi minuti.
                </Text>
                <Text type="h2" mb={32}>
                  Attendere...
                </Text>
              </>
            )}
            {Object.keys(printStatus || {}).map((k) => (
              <LoadingStep key={`print_${k}`} className="d-flex">
                <Text type="b3">{getLabelByReportType(k)}</Text>
                {printStatus[k] === 'ok' ? (
                  <Icon type="check-circle" clickable={false} size={24} />
                ) : printStatus[k] === 'ko' ? (
                  <Icon type="x-circle" clickable={false} size={24} />
                ) : (
                  <Icon
                    type="loading-01"
                    className="rotating"
                    clickable={false}
                    size={24}
                  />
                )}
              </LoadingStep>
            ))}
          </>
        ) : (
          <GridContainer>
            <fieldset>
              <TypeSelector className="select-all">
                <Text type="h3" tag="legend">
                  Aree di interesse
                </Text>
              </TypeSelector>
              <TabSelector
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                onClickReport={onClickReport}
                tabName={EXPORT_TABS.CHARTS}
                label="Grafici"
                checked={selectedReports?.includes(EXPORT_TABS.CHARTS)}
              />
              <TabSelector
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                onClickReport={onClickReport}
                tabName={EXPORT_TABS.COURSES}
                label="Percorsi formativi"
                checked={selectedReports?.includes(EXPORT_TABS.COURSES)}
              />
              <TabSelector
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                onClickReport={onClickReport}
                tabName={EXPORT_TABS.USERS}
                label="Utenti"
                checked={selectedReports?.includes(EXPORT_TABS.USERS)}
              />
              {isSupervisor && (
                <>
                  <TabSelector
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    onClickReport={onClickReport}
                    tabName={EXPORT_TABS.TUTORS}
                    label="Tutors"
                    checked={selectedReports?.includes(EXPORT_TABS.TUTORS)}
                  />
                  <TabSelector
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    onClickReport={onClickReport}
                    tabName={EXPORT_TABS.CATEGORIES}
                    label="Aree tematiche"
                    checked={selectedReports?.includes(EXPORT_TABS.CATEGORIES)}
                  />
                  <TabSelector
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    onClickReport={onClickReport}
                    tabName={EXPORT_TABS.ACTIVITIES}
                    label="Attività"
                    checked={selectedReports?.includes(EXPORT_TABS.ACTIVITIES)}
                  />
                </>
              )}
            </fieldset>
            <div className="type-wrapper">{renderTab()}</div>
          </GridContainer>
        )}
      </ScrollableArea>
      <Footer pt={16} pb={16}>
        <CTA
          type="secondary"
          btnText="chiudi"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        {!isPrinting && (
          <CTA
            type="primary"
            btnText="esporta"
            fullsize={mediaIsPhone}
            disabled={btnDisabled()}
            onClick={() => {
              setIsPrinting(true);
              startDownload();
            }}
          />
        )}
      </Footer>
    </Modal>
  );
};

ModalDownloadReport.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  isOpen: PropTypes.bool,
  currentId: PropTypes.string,
  printSettings: PropTypes.object,
  printStatus: PropTypes.object,
  isSupervisor: PropTypes.bool,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  //* csv charts
  multiPrintMyChartsCSV: PropTypes.func,
  printAccessCSV: PropTypes.func,
  printMyTutorsCSV: PropTypes.func,
  printCateoriesCSV: PropTypes.func,
  printCoursesCSV: PropTypes.func,
  printActivitiesCSV: PropTypes.func,
  //* others
  multiPrintMyCourses: PropTypes.func,
  multiPrintMyUsers: PropTypes.func,
  printMyTutors: PropTypes.func,
  printMyCategories: PropTypes.func,
  multiPrintMyActivities: PropTypes.func,
  resetPrintSettings: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const {
        modal: { id: currentId, isOpen },
      } = state.app;
      const { printSettings, printStatus } = state.statistics;
      const { isSupervisor } = state.user;
      return { isOpen, currentId, printSettings, printStatus, isSupervisor };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      resetPrintSettings: () => dispatch({ type: PRINT_SETTINGS_RESET }),
      getUsers: (filters) =>
        dispatch({ type: STATS_USER_LIST._REQUEST, filters, saveIn: 'both' }),
      //* csv charts
      multiPrintMyChartsCSV: ({
        completion_status_array,
        filters,
        start_date,
        end_date,
      }) =>
        dispatch({
          type: MULTI_PRINT_MY_CHARTS_CSV._REQUEST,
          completion_status_array,
          filters,
          start_date,
          end_date,
          key: 'csv_charts_users',
        }),
      printAccessCSV: (filters) =>
        dispatch({
          type: PRINT_ACCESS_CSV._REQUEST,
          filters,
          key: 'csv_charts_access',
        }),
      printMyTutorsCSV: () =>
        dispatch({
          type: PRINT_MY_TUTORS_CSV._REQUEST,
          key: 'csv_charts_tutors',
        }),
      printCateoriesCSV: (filters) =>
        dispatch({
          type: PRINT_CATEGORIES_CSV._REQUEST,
          filters,
          key: 'csv_charts_categories',
        }),
      printCoursesCSV: ({ type_array, start_date, end_date }) =>
        dispatch({
          type: PRINT_COURSES_CSV._REQUEST,
          type_array,
          start_date,
          end_date,
          key: 'csv_charts_courses',
        }),
      printActivitiesCSV: (filters) =>
        dispatch({
          type: PRINT_ACTIVITIES_CSV._REQUEST,
          filters,
          key: 'csv_charts_activities',
        }),
      //* others
      multiPrintMyCourses: ({ export_types, course_ids, courses }) =>
        dispatch({
          type: MULTI_PRINT_MY_COURSES._REQUEST,
          export_types,
          course_ids,
          courses,
          key: 'courses',
        }),
      multiPrintMyUsers: ({ export_types, filters }) =>
        dispatch({
          type: MULTI_PRINT_MY_USERS._REQUEST,
          export_types,
          filters,
          key: 'users',
        }),
      printMyTutors: ({ filters }) =>
        dispatch({
          type: PRINT_MY_TUTORS._REQUEST,
          filters,
          key: 'tutors',
        }),
      printMyCategories: ({ filters }) =>
        dispatch({
          type: PRINT_MY_CATEGORIES._REQUEST,
          filters,
          key: 'categories',
        }),
      multiPrintMyActivities: ({ export_types, filters }) =>
        dispatch({
          type: MULTI_PRINT_MY_ACTIVITIES._REQUEST,
          export_types,
          filters,
          key: 'activities',
        }),
    })
  ),
  withMediaQueries
)(ModalDownloadReport);
